export default __webpack_public_path__ + "static/media/panel.c1b42619.svg";